var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUpgrade = function SvgUpgrade(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0C0C0F",
    d: "M7.25 19.5V18h9.5v1.5zm4-3.692V7.354l-2.86 2.844-1.044-1.044L12 4.5l4.654 4.654-1.044 1.044-2.86-2.844v8.454z"
  })));
};
export default SvgUpgrade;